<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row" :class="!propUnivDetail ? '' : 'modal_Header_spacing'">
          <div class="col-12 col-md-8 col-lg-8">
            <h4>
              <i class="fa fa-book-open-reader" aria-hidden="true" style="font-size: 24px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp;
              {{cvCardTitle}}
            </h4>
          </div>
          <div class="col-12 col-md-4 col-lg-4">
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="gotoUniCourDashboard" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'">{{cvUnicourseDashboard}}</b-button>
          </div>
          <div class="col-12">
            <h5>{{ orgListObj.org_name }}</h5>
            <h6>{{ orgListObj.org_city }} | {{ orgListObj.org_state}} | {{ orgListObj.org_country}}</h6>
            <h6 v-if="orgListObj.org_admission_requirement">Admission Requirements:&nbsp;<span v-html="orgListObj.org_admission_requirement"></span></h6>
            <h6 v-if="orgListObj.org_rank">Rank: {{ orgListObj.org_rank }}</h6>
            <h6 v-if="orgListObj.org_rating">Rating: {{ orgListObj.org_rating }}</h6>
          </div>
        </div>
        <div class="iq-card row p-3">
          <b-col md="12" v-if="organisationCourseObjList && organisationCourseObjList.length > 0">
            <b-row class="p-2">
              <div v-for="(org,index) in organisationCourseObjList" :key="index" class="mt-2 col-12 col-sm-6 col-md-6 col-lg-6">
                <iq-card className="iq-card-block iq-card-stretch iq-card-height side_border">
                  <template v-slot:body>
                    <div class="orgDetails">
                      <p class="programs">Course Name:
                        <span v-if="org.cour_name">{{ org.cour_name }}</span>
                        <span v-else>NA</span>
                      </p>
                      <p class="programs">Degree Name:
                        <span v-if="org.cour_degree_name">{{ org.cour_degree_name }}</span>
                      </p>
                      <b-button v-if="userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11111'" class="btn btn actionIcon mr-1 mb-1 btn-sm pointer" size="sm" @click="organisationCourseEdit('MODAL', org)">
                        <i class="ri-ball-pen-fill font-size-20 primary-color m-0"></i>
                      </b-button>
                    </div>
                  </template>
                </iq-card>
              </div>
            </b-row>
          </b-col>
          <b-col md="12" v-else>
            No data found
          </b-col>
        </div>
      </b-col>
    </b-row>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>

    <b-modal v-model="showModelUniversityCourseEdit" scrollable :title="cvEditModalHeader" size="xl">
      <UniversityCourseEdit :propOpenedInModal="true" :propUniversityCourseObj="organisationCourseEditObj" @emitCloseUniversityCourseEditModal="closeUniversityCourseEditModal" />
      <template >
        <b-button size="sm" class="pull-left" @click="organisationCourseEdit('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import { UniversityCourses } from "../../../../FackApi/api/universityCourse.js"
import { socialvue } from "../../../../config/pluginInit.js"
import { Organisations } from "../../../../FackApi/api/organisation"
import UniversityCourseEdit from "./UniversityCourseEdit.vue"

export default {
  name: "UniversityCourseList",
  props: {
    propUnivDetail: {
      type: Object,
      default: null
    }
  },
  components: {
    UniversityCourseEdit
  },
  data () {
    return {
      apiName: "organisation_course_list",
      cvCardTitle: "University Courses",
      cvSearchText: "Type to Search",
      organisationCourseObjList: [],
      filterOn: [],
      filter: null,
      cvOrgId: null,
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "University Course",
      sortBy: "name",
      totalRows: 1,
      currentPage: 1,
      perPage: 200,
      orgName: "",
      orgListObj: {},
      cvUnicourseDashboard: "Course Dashboard",
      showModelUniversityCourseEdit: false,
      cvEditModalHeader: "Edit University Course",
      organisationCourseEditObj: null,
      cvbtnModalExpand: "Expand"
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  beforeMount () {
  },
  mounted () {
    socialvue.index()
    this.cvOrgId = this.$route.params.org_id
    this.organisationCourseList()
    this.organisationView()
  },
  methods: {
    /**
     * organisationCourseList
     */
    async organisationCourseList (loadViaLoadMore = false) {
      try {
        let payload = {}

        if (this.propUnivDetail) {
          payload.org_id = this.propUnivDetail.org_id
        }

        if (this.cvOrgId) {
          payload.org_id = this.cvOrgId
        }

        let organisationCourseListResp = await UniversityCourses.organisationCourseList(this, payload)
        if (organisationCourseListResp.resp_status) {
          this.organisationCourseObjList = organisationCourseListResp.resp_data.data
          if (!loadViaLoadMore) {
            this.organisationCourseObjList = [ ...organisationCourseListResp.resp_data.data ]
          }
          else {
            this.organisationCourseObjList = [ ...this.organisationCourseObjList, ...organisationCourseListResp.resp_data.data ]
          }
          this.orgName = this.organisationCourseObjList[0].org_name
          this.totalRows = organisationCourseListResp.resp_data.count
        }
        else {
          this.toastMsg = organisationCourseListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.log("Exception occurred at organisationCourseList() and Exception:", err.message)
      }
    },
    /**
     * organisationView
     */
    async organisationView () {
      let orgId = this.$route.params.org_id
      try {
        let orgListResp = await Organisations.organisationView(this, orgId, null, this.userData.user_role)
        if (orgListResp && !orgListResp.resp_status) {
          return false
        }
        else {
          this.orgListObj = orgListResp.resp_data.data

          // set organisation country
          if (orgListResp.resp_data.data.country_id && orgListResp.resp_data.data.country_name) {
            this.orgListObj.org_country = {
              id: orgListResp.resp_data.data.country_id,
              country_name: orgListResp.resp_data.data.country_name
            }
          }

          this.orgUid = orgListResp.resp_data.data.org_uid
          if (this.orgListObj.org_uid) {
            this.isContactDetailsSaveBtnDisabled = false
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at organisationView() and Exception:", err.message)
      }
    },
    /**
     * organisationCourseEdit
     */
    organisationCourseEdit (type, item) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/organisationCourse_edit/" + this.organisationCourseEditObj.cour_id)
        }
        else {
          this.organisationCourseEditObj = item
          this.showModelUniversityCourseEdit = true
        }
      }
      catch (err) {
        console.error("Exception occurred at organisationCourseEdit() and Exception:", err.message)
      }
    },
    /**
     * closeUniversityCourseEditModal
     */
    closeUniversityCourseEditModal () {
      try {
        this.showModelUniversityCourseEdit = false
      }
      catch (err) {
        console.error("Exception occurred at closeUniversityCourseEditModal() and Exception:", err.message)
      }
    },
    /**
     * goto Uni Cour Dashboard
     */
    gotoUniCourDashboard () {
      window.open(`/organisationCourse/${this.cvOrgId}`)
    }
  }
}
</script>
<style lang="scss">
  .orgDetails .org_name{
    font-size: 16px;
    font-weight: 500;
    color: #000;
    margin:0px;
    margin-bottom: 5px;
    line-height: 25px;
  }
  .orgDetails .org_ra{
    font-size: 15px;
    color: #000;
    margin-bottom: 0px;
    span{
      color:#777;
    }
  }
  .orgDetails .programs{
    margin: 0px;
    color: #000;
    span{
      color:#777;
    }
  }
</style>
